// Valid :subpage values for the /routes/:route_id/:subpage(/...) routes.
// Shared by the Route details tabs and by Route-level 404 validation in
// every component mounted under a :subpage route — keep in sync with the tabs.
export const ROUTE_SUBPAGES = ["overview", "provider", "destinations", "sources", "logs", "webhook", "configurations"] as const;

// An absent subpage is valid (it defaults to "overview" / doesn't apply).
export const isValidRouteSubpage = (subpage?: string): boolean =>
    !subpage
    || ROUTE_SUBPAGES.includes(subpage as typeof ROUTE_SUBPAGES[number]);
